<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">

        <!-- Add notice form -->
        <div class="card p-4 lg:p-6">
            <h6 class="card-title">Create Class</h6>
            <form>
                <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label class="form-label">Class Type*</label>
                        <select class="form-input" v-model="classes.classtype" required>
                            <option disabled value="0">SELECT CLASS TYPE</option>
                            <option value="group">Group Classes</option>
                            <option value="personal">Persnal Training</option>
                        </select>
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label class="form-label">Staff List*</label>
                        <select class="form-input" v-model="classes.staffid" required>
                            <!-- <option disabled value="">SELECT STAFF</option> -->
                            <option v-for="(item, index) in classlist" :value="item.id">{{ item.staff_name }}</option>
                        </select>
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label class="form-label">Start Date *</label>
                        <input type="date" v-model="classes.startdate" placeholder="Select Date" class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label class="form-label">End Date *</label>
                        <input type="date" v-model="classes.enddate" placeholder="Select Date" class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label class="form-label">Description *</label>
                        <input type="text" v-model="classes.description" placeholder="Type here" class="form-input" required autocomplete="off">
                    </div>

                </div>
            </form>
            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6">
                Add Class
            </button>

        </div>
    </div>
</template>


<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
    name: 'AddProduct',
    components: {

    },
    mounted() {
        this.getBasics();
        // $(".form-input").on('keyup')
    },
    data() {
        return {
            isAdd: 0,
            isEdit: 0,
            isDelete: 0,
            deleteId: 0,
            catList: [],
            classlist:[],
            lead: { 
                name: '', 
                contact:'',
                address:'',
                gender:'',
                age:'',
                nextdate:this.today(),
                remark:'',
            
            },

            classes:{

                classtype:'',
                staffid:'',
                startdate:'',
                enddate:'',
                description:'',

          },



            // employees: { empname: '', emprole: '0', isMainAdmin: 0 },
        }
    },
    methods: {
        today()
        {
        const dateObj = new Date();
        var day=dateObj.getDate();
        var month=dateObj.getMonth()+1;
        
        const currentDate = ((day<10)?'0'+day:day)+"/"+((month<10)?'0'+month:month)+"/"+dateObj.getFullYear();
        return currentDate;
        },
        async getBasics() {
            var self = this;
            axios.post('getclass').then(function (response) {
                self.classlist = response.data.classes;
                console.log(self.classlist);
                self.employees = response.data.userDetails;
            });
        },
        nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },

        
        save() {
             var self = this;
             console.log("Payload: ", self.classes);

if (self.classes.classtype === '' || self.classes.staffid === '0') {
    self.$swal("Please select a valid staff member");
}
            else {
                // self.classes.staffid = self.staffid;
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('getclass', this.classes)
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                // self.catList = response.data.cats;
                                // self.employees = response.data.userDetails;
                                // self.cat = { name: '', status: 'Active' };
                                if (isSuccess == 1) {
                                   // $("#barcode").focus();
                                }


                                self.$swal(msg);

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });
            }

        }












    }
}
</script>
